/* ============================================================================
   LAH — ENVIO TURBO: tela de escolha antes do carrinho
   Tema: Testes de implementacao (0.7)

   ============================================================================
   A JANELA: SO EM DIA UTIL, ANTES DAS 12H
   ============================================================================
   Fora dela o clique passa direto para o carrinho, como se o recurso nao
   existisse. Fim de semana e feriado tambem ficam de fora — nao ha versao
   degradada da oferta.

   A razao veio de um questionamento de cliente: se a pagina promete envio em
   1 dia util, oferecer no fim do fluxo uma escolha que tambem nao entrega hoje
   soa contraditorio. Dentro da janela, o Turbo significa uma coisa so: sai
   hoje.

   Efeito colateral bom: a oferta fica escassa por natureza — existe de manha,
   em dia util — sem contador nem pressao artificial.

   ============================================================================
   COMO AS DATAS SAO DITAS
   ============================================================================
     TURBO ........ "envio hoje"
     PADRAO ....... "envio amanha, 18/09" quando o proximo dia util e amanha
                    "envio segunda, 22/09" quando nao e

   "Amanha" so aparece quando amanha e, de fato, o dia do envio. Numa
   sexta-feira o proximo dia util e segunda, e dizer "amanha" seria falso — dai
   a checagem de calendario antes de escolher a palavra.

   A data acompanha o rotulo sempre, inclusive com "amanha": quem le rapido
   pega a palavra, quem confere pega o numero.

   ============================================================================
   A TROCA DA VARIANTE
   ============================================================================
   Interceptamos /cart/add.js e trocamos Resina (149) por Resina Envio Turbo
   (168). Mesma lente, segundo preco: nenhum produto novo, nenhuma linha extra
   na nota. Removendo este arquivo, o fluxo volta ao original.
   ============================================================================ */

(function () {
    'use strict';

    var CORTE_HORA = 12;

    var VARIANTE_COMUM = 39936307626036;
    var VARIANTE_TURBO = 48350293786676;

    var tela = document.querySelector('[data-lah-turbo]');
    if (!tela) return;

    var agoraISO = tela.getAttribute('data-agora');
    if (!agoraISO) return;

    var refServidor = new Date(agoraISO.replace(' ', 'T'));
    if (isNaN(refServidor.getTime())) return;

    var defasagem = refServidor.getTime() - Date.now();
    var raiz = document.querySelector('.product-lens-select');

    var liberado = false;
    var respondido = false;

    function agora() { return new Date(Date.now() + defasagem); }

    function track(evento, dados) {
        try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(Object.assign({ event: evento }, dados || {}));
        } catch (e) { /* analytics nunca deve quebrar a venda */ }
    }

    function normalize(t) {
        return (t || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    }

    /* =====================================================================
       CALENDARIO
       ===================================================================== */
    function pascoa(ano) {
        var a = ano % 19, b = Math.floor(ano / 100), c = ano % 100;
        var d = Math.floor(b / 4), e = b % 4;
        var f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3);
        var h = (19 * a + b - d - g + 15) % 30;
        var i = Math.floor(c / 4), k = c % 4;
        var l = (32 + 2 * e + 2 * i - h - k) % 7;
        var m = Math.floor((a + 11 * h + 22 * l) / 451);
        var mes = Math.floor((h + l - 7 * m + 114) / 31);
        var dia = ((h + l - 7 * m + 114) % 31) + 1;
        return new Date(ano, mes - 1, dia, 12, 0, 0);
    }

    function chave(d) {
        var m = d.getMonth() + 1, dia = d.getDate();
        return d.getFullYear() + '-' + (m < 10 ? '0' + m : m) + '-' + (dia < 10 ? '0' + dia : dia);
    }

    function somaDias(base, dias) {
        var d = new Date(base.getTime());
        d.setDate(d.getDate() + dias);
        return d;
    }

    var cacheFeriados = {};

    function feriados(ano) {
        if (cacheFeriados[ano]) return cacheFeriados[ano];
        var l = [ano + '-01-01', ano + '-04-21', ano + '-05-01', ano + '-09-07',
                 ano + '-10-12', ano + '-11-02', ano + '-11-15', ano + '-11-20',
                 ano + '-12-25'];
        var p = pascoa(ano);
        l.push(chave(somaDias(p, -48)), chave(somaDias(p, -47)),
               chave(somaDias(p, -2)), chave(somaDias(p, 60)));
        cacheFeriados[ano] = l;
        return l;
    }

    function ehDiaUtil(d) {
        var w = d.getDay();
        if (w === 0 || w === 6) return false;
        return feriados(d.getFullYear()).indexOf(chave(d)) === -1;
    }

    function proximoDiaUtil(d) {
        var r = somaDias(d, 1), v = 0;
        while (!ehDiaUtil(r) && v < 30) { r = somaDias(r, 1); v++; }
        return r;
    }

    function dentroDaJanela() {
        var hoje = agora();
        return ehDiaUtil(hoje) && hoje.getHours() < CORTE_HORA;
    }

    var DIAS = ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'];

    function ddmm(d) {
        return ('0' + d.getDate()).slice(-2) + '/' + ('0' + (d.getMonth() + 1)).slice(-2);
    }

    /* "Amanha" so quando amanha e mesmo o dia do envio. Numa sexta o proximo
       dia util e segunda, e a palavra seria falsa — dai a comparacao com o dia
       seguinte do calendario, nao com o proximo dia util. */
    function rotuloEnvio(destino, hoje) {
        var amanha = somaDias(hoje, 1);

        if (chave(destino) === chave(amanha)) {
            return 'envio amanhã, ' + ddmm(destino);
        }

        return 'envio ' + DIAS[destino.getDay()] + ', ' + ddmm(destino);
    }

    /* =====================================================================
       ELEGIBILIDADE DA COMBINACAO

       So as lentes prontas em estoque: espessura Normal com tratamento
       Classico ou Filtro de luz azul. Qualquer sinal de multifocal,
       fotossensivel ou solar desqualifica — inclusive "Filtro azul +
       Fotossensivel", que contem "filtro de luz azul" no nome e passaria por
       uma checagem ingenua.
       ===================================================================== */
    function elegivel() {
        if (!raiz) return false;

        var itens = Array.prototype.map.call(
            raiz.querySelectorAll('.product-lens-select-item.selected'),
            function (el) { return normalize(el.getAttribute('data-item-name')); }
        );

        if (!itens.length) return false;

        var bloqueia = itens.some(function (n) {
            return n.indexOf('multifocal') !== -1 ||
                   n.indexOf('fotossens') !== -1 ||
                   n.indexOf('solar') !== -1 ||
                   n.indexOf('sem grau') !== -1;
        });
        if (bloqueia) return false;

        return itens.some(function (n) { return n === 'normal'; }) &&
               itens.some(function (n) { return n === 'classico' || n === 'filtro de luz azul'; });
    }

    /* =====================================================================
       PINTURA
       ===================================================================== */
    var elAgora = tela.querySelector('[data-turbo-agora]');
    var elDataComum = tela.querySelector('[data-turbo-data-comum]');
    var elDataTurbo = tela.querySelector('[data-turbo-data-turbo]');

    function pintar() {
        var hoje = agora();
        var padrao = proximoDiaUtil(hoje);

        if (elAgora) {
            elAgora.textContent = 'Hoje é ' + DIAS[hoje.getDay()] + ', ' + ddmm(hoje) + ', ' +
                ('0' + hoje.getHours()).slice(-2) + 'h' + ('0' + hoje.getMinutes()).slice(-2);
        }

        if (elDataComum) elDataComum.textContent = rotuloEnvio(padrao, hoje);
        if (elDataTurbo) elDataTurbo.textContent = 'envio hoje';
    }

    /* =====================================================================
       ABRIR, FECHAR E TROCAR DE VISTA
       ===================================================================== */
    function vista(nome) {
        tela.setAttribute('data-turbo-vista', nome);
        var box = tela.querySelector('.lah-turbo-tela__box');
        if (box) box.scrollTop = 0;
    }

    function abrir() {
        pintar();
        vista('escolha');
        tela.classList.add('is-open');
        document.body.classList.add('hidden-scroll');
        track('lens_turbo_tela', {});
    }

    function fechar() {
        tela.classList.remove('is-open');
        document.body.classList.remove('hidden-scroll');
    }

    function turboAtivo() {
        return tela.getAttribute('data-turbo-escolha') === 'turbo';
    }

    /* ---- Intercepta o "Adicionar ao carrinho", em captura ---- */
    document.addEventListener('click', function (event) {
        if (liberado || respondido) return;

        var botao = event.target.closest ? event.target.closest('.lens-footer-button') : null;
        if (!botao) return;

        /* O mesmo botao serve a varias etapas; so nos interessa o do resumo,
           que e o unico com o bloco de preco visivel ao lado. */
        var preco = document.querySelector('.product-lens-footer-price');
        if (!preco || preco.offsetParent === null) return;

        if (!dentroDaJanela()) return;
        if (!elegivel()) return;

        event.preventDefault();
        event.stopPropagation();

        abrir();
    }, true);

    /* ---- Interacoes dentro da tela ---- */
    tela.addEventListener('click', function (event) {
        var opcao = event.target.closest('[data-turbo-opcao]');

        if (opcao) {
            var valor = opcao.getAttribute('data-turbo-opcao');

            Array.prototype.forEach.call(
                tela.querySelectorAll('[data-turbo-opcao]'),
                function (el) { el.classList.toggle('is-on', el === opcao); }
            );

            tela.setAttribute('data-turbo-escolha', valor);
            track('lens_turbo_escolha', { opcao: valor });
            return;
        }

        if (event.target.closest('[data-turbo-abrir]')) {
            vista('info');
            track('lens_turbo_saibamais', {});
            return;
        }

        /* "Entendi" devolve ao seletor, nao fecha a tela: o cliente foi ler
           para decidir, entao precisa voltar exatamente para a decisao. */
        if (event.target.closest('[data-turbo-voltar]')) {
            vista('escolha');
            return;
        }

        if (event.target.closest('[data-turbo-continuar]')) {
            respondido = true;
            liberado = true;
            fechar();

            var botao = document.querySelector('.lens-footer-button');
            if (botao) botao.click();

            liberado = false;
            return;
        }

        /* Fechar sem responder nao marca como respondido — fechar por engano
           nao deve custar a oferta. */
        if (event.target.closest('[data-turbo-cancelar]') || event.target === tela) {
            track('lens_turbo_dispensado', {});
            fechar();
        }
    });

    document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        if (!tela.classList.contains('is-open')) return;

        if (tela.getAttribute('data-turbo-vista') === 'info') {
            vista('escolha');
            return;
        }

        track('lens_turbo_dispensado', {});
        fechar();
    });

    /* =====================================================================
       TROCA DA VARIANTE

       A janela e checada tambem aqui: se o cliente deixar a tela aberta e
       atravessar as 12h antes de confirmar, o pedido nao pode sair com a
       variante Turbo — ele pagaria por um envio que nao acontece mais hoje.
       ===================================================================== */
    function trocar(corpo) {
        if (!turboAtivo()) return corpo;
        if (!dentroDaJanela()) return corpo;
        if (typeof corpo !== 'string') return corpo;
        if (corpo.indexOf(String(VARIANTE_COMUM)) === -1) return corpo;

        track('lens_turbo_aplicado', {});
        return corpo.split(String(VARIANTE_COMUM)).join(String(VARIANTE_TURBO));
    }

    var fetchOriginal = window.fetch;

    if (typeof fetchOriginal === 'function') {
        window.fetch = function (recurso, opcoes) {
            try {
                var url = typeof recurso === 'string' ? recurso : (recurso && recurso.url) || '';
                if (url.indexOf('/cart/add') !== -1 && opcoes && typeof opcoes.body === 'string') {
                    opcoes = Object.assign({}, opcoes, { body: trocar(opcoes.body) });
                }
            } catch (e) { /* segue com a chamada original */ }
            return fetchOriginal.apply(this, [recurso, opcoes]);
        };
    }

    var XHROpen = window.XMLHttpRequest.prototype.open;
    var XHRSend = window.XMLHttpRequest.prototype.send;

    window.XMLHttpRequest.prototype.open = function (metodo, url) {
        this.__lahUrl = url;
        return XHROpen.apply(this, arguments);
    };

    window.XMLHttpRequest.prototype.send = function (corpo) {
        try {
            if (this.__lahUrl && this.__lahUrl.indexOf('/cart/add') !== -1) {
                corpo = trocar(corpo);
            }
        } catch (e) { /* segue com o corpo original */ }
        return XHRSend.call(this, corpo);
    };
})();
